import React from "react";
import SidebarAbout from "./SidebarAbout.jsx";
import SidebarConcerts from "./SidebarConcerts.jsx";
import SidebarPlayer from "./SidebarPlayer.jsx";

import "./sidebar.css";

const Sidebar = ({ lang }) => {
  return (
    <div className="sidebarContainer">
      <SidebarPlayer lang={lang} />
      <SidebarConcerts lang={lang} />
      <SidebarAbout lang={lang} />
    </div>
  );
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/Sidebar.jsx